// Anonymous shortlist storage for the /providers map.
//
// A "save" (bookmark) is NOT an interest swipe: it must never fire recruiter
// contact or open a negotiation, so it does NOT reuse anonymousSwipeStorage
// (which POSTs to /swipes/anonymous on write). Saves live under their own
// localStorage key and stay local until a follow-up wires them into the
// auth-time reconcile pipeline. See the note in the growth-frontend summary.

export const SHORTLIST_KEY = 'rxrooster_anon_shortlist';

/**
 * Pure toggle: returns a new array with `id` added if absent, removed if
 * present. Tolerant of a non-array input (treated as empty).
 * @param {string[]} ids
 * @param {string} id
 * @returns {string[]}
 */
export const toggleShortlistId = (ids, id) => {
    const list = Array.isArray(ids) ? ids : [];
    return list.includes(id) ? list.filter((x) => x !== id) : [...list, id];
};

/**
 * Read the persisted shortlist ids. Never throws: a missing or corrupt store
 * resolves to an empty list.
 * @returns {string[]}
 */
export const readShortlistIds = () => {
    try {
        const raw = localStorage.getItem(SHORTLIST_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed?.ids)
            ? parsed.ids.filter((x) => typeof x === 'string')
            : [];
    } catch {
        return [];
    }
};

/**
 * Persist the shortlist ids. Never throws (private-mode / quota failures are
 * swallowed). Returns whether the write succeeded.
 * @param {string[]} ids
 * @returns {boolean}
 */
export const writeShortlistIds = (ids) => {
    try {
        const list = (Array.isArray(ids) ? ids : []).filter(
            (x) => typeof x === 'string',
        );
        localStorage.setItem(SHORTLIST_KEY, JSON.stringify({ ids: list }));
        return true;
    } catch {
        return false;
    }
};
